import styled, { keyframes, css } from 'styled-components';

import { PinkTriangle, TealRectangle, TealCircle, TealTriangle } from './Decorations';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const pinkTriangleCss = css`
  left: -50px;
  width: 200px;
  bottom: 100px;

  @media screen and (min-width: 768px) {
    bottom: 0;
  }

  @media screen and (min-width: 1200px) {
    bottom: 140px;
  }
`;

const tealTriangleCss = css`
  bottom: 0px;
  left: -80px;
  width: 200px;
`;

const tealCircleCss = css`
  right: -53px;
  width: 120px;
  bottom: 6px;
`;

const tealCircleCss2 = css`
  right: 60px;
  width: 100px;
  top: 80px;
`;

const tealRectangleCss = css`
  left: 644px;
  width: 180px;
  top: 458px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  color: #1d0b4b;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em 12px;
  border-bottom: 4px solid white;
  width: 100%;
  font-size: 0.9em;
  opacity: 0;
  animation: ${fadeIn} 200ms linear forwards;
  > button {
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 2px solid #D7C2F0;
    color: #D7C2F0;
    transition: all 200ms ease-out;
    > i {
      font-size: 2em;
      transform: translateX(-2px);
    }
    &:hover {
      color: #b59cd3;
      border-color: #b59cd3;
    }
  }

  @media screen and (min-width: 768px) {
    padding: 0.5em 1.5em;
  }
`;

const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  opacity: 0;
  animation: ${fadeIn} 200ms linear forwards;
  animation-delay: 100ms;
`;

const Body = styled.main`
  padding: 12px;
  display: flex;
  flex-direction: column-reverse;
  h4 {
    font-size: 1.5em;
    margin: 0;
  }
  .cta {
    background: #1d0b4b;
    color: #F8F2FF;
    transition: background 200ms ease-out;
    width: 100%;
    padding: 14px;
    border-radius: 16px;
    font-weight: 500;
    margin-bottom: 16px;
    margin-top: auto;
    display: flex;
    justify-content: center;
    color: white;
    text-decoration: none;
    &:hover {
      background: #5734ab;
    }
    &:link, &:visited {
      color: white;
    }
  }
  a, a:link, a:visited {
    color: #5835AB;
    font-weight: 500;
  }
  a:hover {
    color: #5734ab;
  }

  @media screen and (min-width: 768px) {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 12px;
    .cta {
      margin-bottom: 0;
    }
  }

  @media screen and (min-width:1024px) {
    padding: 32px;
    grid-gap: 16px;
  }
`;

const Video = styled.div`
  border-radius: 8px;
  opacity: 0;
  overflow: hidden;
  animation: ${fadeIn} 500ms linear forwards;
  animation-delay: 300ms;
  background: black;
  iframe {
    min-height: 180px;
    width: 100%;
  }

  @media screen and (min-width: 768px) {
    iframe {
      min-height: 360px;
    }
  }
`;

const InstaFeed = styled.div`
  text-align: center;
  padding: 12px;
  width: 100%;
  margin-top: 32px;
  opacity: 0;
  animation: ${fadeIn} 200ms linear forwards;
  animation-delay: 400ms;
  h2 {
    font-size: 1.75em;
    margin: 0;
    color: #5734ab;
  }
  h3 {
    font-size: 1.2em;
    font-weight: 500;
    color: #5734ab;
    > span {
      color: #1d0b4b;
    }
  }
  .eapps-instagram-feed-posts-grid-load-more-text {
    background: #1d0b4b !important;
    border-radius: 4px;
  }
`;

const Decorations = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;

  @media screen and (min-width: 1200px) {
    overflow: unset;
  }
`;

export const Content = ({ data, handleBack }) => {
  return (
    <Wrapper>
      <Header>
        <button onClick={handleBack}>
          <i className="fa fa-angle-left"></i>
        </button>
        <h3>#BodySlimsHealthyHabits</h3>
      </Header>
      <Body>
        <Decorations>
          <TealCircle styles={tealCircleCss2} />
          <TealRectangle styles={tealRectangleCss} />
          <TealCircle styles={tealCircleCss} />
          <PinkTriangle styles={pinkTriangleCss} />
          <TealTriangle styles={tealTriangleCss} />
        </Decorations>
        <Video>
          <iframe title="Bodyslims Content" src={data.video} frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
        </Video>
        <BodyContent>
          <h4>{data.name}</h4>
          {data.descriptions.map((d, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: d.replace(/({{)(.+)(}})/, `<a href=${data.linkUrl} target="_blank" rel="noopener noreferrer">$2</a>`) }} />
          ))}
          {!data.inlineLink && <a style={{ marginBottom: 8 }} href={data.linkUrl} target="_blank" rel="noopener noreferrer">{data.linkText}</a>}
          <a className="cta" href=" https://lp.constantcontactpages.com/su/0seBJQo" target="_blank" rel="noopener noreferrer">Sign-Up to our newsletter for more tips</a>
        </BodyContent>
      </Body>
      <InstaFeed>
        <h2>What are you doing for yourself today?</h2>
        <h3>Share your healthy habits with us on Instgram using <span>#BodyslimsHealthyHabits</span></h3>
        <div className="elfsight-app-07771456-3ba5-4516-9e9b-d87084732cc9"></div>
      </InstaFeed>
    </Wrapper>
  );
};